import { memo } from 'react';

import { FileStatusIconCompleted, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { EllipsisInMiddle } from '~/components/EllipsisInMiddle';
import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type BoardRestorationTask, type GetCompletedMetadata } from '~/store/tasks/types';

export type RestoreBoardCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<BoardRestorationTask>;
  onClear: () => void;
};

export const RestoreBoardCompletedPanelItem = memo(
  ({ metadata: { title }, onClear }: RestoreBoardCompletedPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();

    return (
      <PaneItemTW
        truncate={false}
        avatar={<FileStatusIconCompleted size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle>{ui2026 ? 'Board recovered' : 'Recovered successfully'}</FileStatusTitle>}
        subtitle={
          <FileStatusSubtitle className="flex text-nowrap">
            <span className="flex-none pr-1">Recovered board: </span>
            <EllipsisInMiddle className="font-bold" text={title || ''} />
          </FileStatusSubtitle>
        }
        buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
      />
    );
  },
);

RestoreBoardCompletedPanelItem.displayName = 'RestoreBoardCompletedPanelItem';
